// extracted by mini-css-extract-plugin
module.exports = {"noReportWrapper":"noReportWrapper","promptText":"promptText","msg":"msg","createText":"createText"};